import * as React from "react";
import { X } from "lucide-react";
import { Badge } from "./badge.js";
import { cn } from "../../lib/utils.js";

const TagsInput = React.forwardRef(({ value = [], label, onChange, placeholder, className, ...props }, ref) => {
    const [inputValue, setInputValue] = React.useState("");

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            addTag();
        } else if (e.key === "Backspace" && inputValue === "" && value.length > 0) {
            removeTag(value.length - 1);
        }
    };

    const addTag = () => {
        const trimmedInput = inputValue.trim();
        if (trimmedInput && !value.includes(trimmedInput)) {
            onChange([...value, trimmedInput]);
            setInputValue("");
        }
    };

    const removeTag = (index) => {
        const newValue = [...value];
        newValue.splice(index, 1);
        onChange(newValue);
    };

    return (
        <div className="mb-3">
            {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
            <div
                className={cn(
                    "flex min-h-[2.5rem] w-full flex-wrap gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm transition-all has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-blue-500 has-[:focus-visible]:border-blue-500 outline-none",
                    className
                )}
            >
                {value.map((tag, index) => (
                    <Badge key={index} variant="secondary" className="gap-1 pr-1 text-sm py-1 px-3">
                        {tag}
                        <button
                            type="button"
                            onClick={() => removeTag(index)}
                            className="rounded-full ring-offset-background hover:bg-muted focus:ring-2 focus:ring-ring focus:outline-none"
                        >
                            <X size={14} />
                            <span className="sr-only">Remove {tag}</span>
                        </button>
                    </Badge>
                ))}
                <input
                    ref={ref}
                    type="text"
                    className="flex-1 bg-transparent outline-none placeholder:text-muted-foreground min-w-[120px]"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={addTag}
                    placeholder={value.length === 0 ? placeholder : ""}
                    {...props}
                />
            </div>
        </div>
    );
});

TagsInput.displayName = "TagsInput";

export { TagsInput };
